/** Movement below this (px) is treated as a tap, not a swipe. */
export const GESTURE_SWIPE_DEADBAND = {
    DEFAULT: 10,
    /** Higher threshold for fullscreen viewers where pinch-to-zoom must not change slides. */
    VIEWER: 40
} as const;
/** Movement below this (px) is treated as a tap, not a swipe. */
export const GESTURE_SWIPE_DEADBAND = {
    DEFAULT: 10,
    /** Higher threshold for fullscreen viewers where pinch-to-zoom must not change slides. */
    VIEWER: 40
} as const;
